export default __webpack_public_path__ + "static/tech-paper-icon-0ca25ad9514a5b09d63b3d9441bb84fb.png";